module.exports = __webpack_public_path__ + "img/Move-disabled.483ab99a.svg";